import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const SignalSectionRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent"></div>
    <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
      <SectionHeading title="Semnalul și Pragul" subtitle="Actul III" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h3 className="text-white font-display font-bold text-2xl mb-4">Proiectul Odiseea</h3>
          <p className="text-gray-400 leading-relaxed mb-6">
            În actul final, cronica ajunge la Proiectul Odiseea — prima misiune interstelară cu echipaj a umanității, lansată de la Stația Triton în <span className="text-brand-accent font-semibold">2514</span> spre Alpha Centauri, la 4,37 ani-lumină distanță.
          </p>
          <p className="text-gray-400 leading-relaxed">
            Echipajul de 120 de persoane traversează heliopauza în timp ce <span className="text-white">opt miliarde de oameni din opt lumi</span> sting simultan luminile în Priveghiul Luminilor — pulsând ca un singur corp respirând, răspândit pe patru miliarde de kilometri.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 }}>
          <h3 className="text-white font-display font-bold text-2xl mb-4">Semnalul</h3>
          <p className="text-gray-400 leading-relaxed mb-6">
            În regiunile exterioare ale heliosferei, santinelele lui Neptun detectează un semnal — <span className="text-white">recursiv, auto-referențial, cu densitatea informațională a unei minți</span> — sosind dintr-o direcție pe care nicio sursă stelară cunoscută nu o poate explica, posibil călătorind de milioane de ani.
          </p>
          <div className="bg-brand-dark border border-blue-500/20 rounded-xl p-5">
            <p className="text-gray-300 italic text-sm leading-relaxed">
              "Răspundem pentru că ni s-a vorbit. Răspundem pentru că a nu răspunde ar fi prima dată când civilizația noastră alege tăcerea ca răspuns la vocea altei minți — și suntem mai buni de atât."
            </p>
            <p className="text-gray-600 text-xs mt-3">— Filosoful de la bordul Odiseei</p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default SignalSectionRo;